export const SUPER_GROUP_ID = '3720a9ff-192e-4e50-8ddc-51918bfee17a';
export const IMPERSONATE_STORAGE_KEY = 'rozyxvision.impersonate_email';
export const URL_PREFIX = ENV_URL_PREFIX;
export const SERVER_API = {
    url: 'https://zhd8b0hou4.execute-api.ap-northeast-2.amazonaws.com/' +
        ((!ENV_PRODUCTION || URL_PREFIX) ? 'dev' : 'prod') +
        '/api',
    xApiKey: 'RXlJBkXCKi2IZDY0jYGOA5EtdQzF89mzsq1lMHug',
    contentType: 'application/json; charset=utf-8',
    scope: 'tag:rowi-ai.com,2024-06-10:id:scope/tdsk',
};
export const ROWI_API_GATEWAY_PREFIX = 'https://zhd8b0hou4.execute-api.ap-northeast-2.amazonaws.com/';
export const FIREBASE = {
    apiKey: 'AIzaSyBkf60HRt8w-I4eCvZOL1e0JLdjHKyMl-c',
    authDomain: 'rowilab-korea-scanner.firebaseapp.com',
    databaseURL: 'https://rowilab-korea-scanner-default-rtdb.asia-southeast1.firebasedatabase.app',
    projectId: 'rowilab-korea-scanner',
    storageBucket: 'rowilab-korea-scanner.appspot.com',
    messagingSenderId: '1015974665166',
    appId: '1:1015974665166:web:7b775335e722685126a99f',
};
